import React, { useState } from "react";
import GenerateCoupon from "./GenerateCoupon";
import HorizontalTabs from "../../../common/HorizontalTabs";
import GenerateQR from "./GenerateQR";

type Props = {};

const Index = (props: Props) => {
  const [activeTab, setActiveTab] = useState("tab1");
  const tabs = [
    {
      id: "tab1",
      label: "Generate Unique Coupon Codes",
      content: <GenerateCoupon />,
    },
    { id: "tab2", label: "Generate QR Code", content: <GenerateQR /> },
  ];

  return (
    <HorizontalTabs
      tabs={tabs}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};

export default Index;
